module.exports = __webpack_public_path__ + "img/group_systems.0749e7b2.svg";